<app-generic-panel
  [title]="panelTitle"
  [description]="panelDescription"
  [icon]="panelIcon"
>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12">
      <mat-form-field>
        <mat-select
          [(ngModel)]="a3LaboralCompany"
          name="a3LCompanySelect"
          data-size="3"
          placeholder="Empresa"
          [disabled]="!a3LaboralCompanies"
          (selectionChange)="onA3LCompanySelectChange($event)"
          #a3LCompanySelect="ngModel"
        >
          <mat-option
            *ngFor="let company of a3LaboralCompanies"
            [value]="company.companyCode"
          >
            {{ company.companyName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-12">
      <dx-data-grid
        id="gridContainer"
        [dataSource]="dataSource"
        [remoteOperations]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
      >
        <dxo-header-filter [visible]="false"></dxo-header-filter>
        <dxo-group-panel [visible]="false"></dxo-group-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-selection
        [selectAllMode]="'page'"
        [showCheckBoxesMode]="'always'"
        mode="multiple"
    ></dxo-selection>
        <!-- Definición de las columnas -->
        <dxi-column
          dataField="employeeCode"
          caption="Código de empleado"
          alignment="right"
          [filterOperations]="['contains', '=', '<>']"
        >
        </dxi-column>
        <dxi-column
          dataField="completeName"
          caption="Nombre"
          [filterOperations]="['contains', '=', '<>']"
        >
        </dxi-column>

        <dxi-column
          dataField="dropDate"
          caption="Fecha de baja"
          dataType="date"
          alignment="right"
          cellTemplate="dateCell"
        >
        </dxi-column>

        <div *dxTemplate="let cellData of 'dateCell'">
          <!-- Filtro para evitar mostrar las fechas que viene con DateTime.Min de c# -->
          <span *ngIf="cellData.value.getFullYear() !== 1900">
            {{ cellData.value | date: 'dd/MM/yyyy' }}
          </span>
        </div>
      </dx-data-grid>
    </div>

  </div>

  <!-- Botonera -->
  <div class="row">
    <label class="col-md-3"></label>
    <div class="col-md-9">
      <div class="form-group form-button">
        <button
          class="btn btn-fill btn-primary float-right"
          type="button"
          (click) = "onButtonGenerateUserClick()"
          [disabled] = "!this.dataGrid || this.dataGrid.instance.getSelectedRowKeys().length === 0"
        >
          Generar usuarios
          <!-- <fa-icon
            [icon]="['fas', 'spinner']"
            [spin]="true"
            *ngIf="loading"
          ></fa-icon> -->
        </button>

      </div>
    </div>
  </div>
</app-generic-panel>
